import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_SECONDARY_BRAND_ALLOCATION} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const SecondaryBrandAllocation = lazy(() =>
  import('../../../screens/SecondaryBrandAllocation')
    .then(module => ({default: module.SecondaryBrandAllocation})));

const SecondaryBrandAllocationNavigation = [
  {
    path: ROUTE_SECONDARY_BRAND_ALLOCATION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <SecondaryBrandAllocation />
      </Suspense>
    ),
  },
];

export default SecondaryBrandAllocationNavigation;
